import React, { useEffect } from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { loadCities } from 'components/CityPage/actions';
import { urlFromName } from 'shared/models/city';
import LoadingSpinner from 'scy/LoadingSpinner';
import { SmallUppercase } from 'scy/text';
import { relative } from 'scy/position.mod.scss';
import padding from 'scy/padding.mod.scss';
import margin from 'scy/margin.mod.scss';
import { cityList } from './styles.mod.scss';

function sortByName(list) {
  const cities = list || [];
  return cities.sort((cityA, cityB) => {
    if (cityA.name > cityB.name) return 1;
    if (cityA.name < cityB.name) return -1;
    return 0;
  });
}

export default function CityLinks() {
  const dispatch = useDispatch();
  const { list, loading, requestedAt } = useSelector(state => state.cities);

  useEffect(() => {
    const isStale = !requestedAt || requestedAt < new Date() - 10 * 60 * 1000;
    if (isStale && !loading) {
      dispatch(loadCities());
    }
  }, [dispatch, loading, requestedAt]);

  if (loading) {
    return (
      <div className={`${padding.md} ${relative}`}>
        <LoadingSpinner black />
      </div>
    );
  }

  return (
    <ul className={cityList}>
      {sortByName(list).map(({ name }) => (
        <SmallUppercase
          tag="li"
          key={name}
          marginClass={classnames(margin.top_0, margin.bottom_sm)}
        >
          <Link to={urlFromName(name)}>{name}</Link>
        </SmallUppercase>
      ))}
    </ul>
  );
}
